// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c3e52cfc","186":"d8be40f1","225":"70f29149","272":"d01a086f","372":"50be6720","377":"90a2827a","573":"090f4ce7","738":"e6a663c8","841":"20ea16f9","856":"e9658569"}[chunkId] + ".chunk.js";
};